<!-- Fora do `LayoutComponent`: a classe de versão vem da diretiva. -->
<main class="public-screen" appAccountVersionTheme>
  <div class="public-card">
    <div class="brand-bar"></div>
    <div class="public-card-body">
      <div class="logo">
        <img
          src="/assets/logo-smsfunnel-login.png"
          alt="SMS Funnel"
          title="SMS Funnel"
        />
      </div>
      <!-- `action` fixo: sem ele o navegador usa a URL da página, e o GA4 manda o
           token da rota no `form_destination` do evento `form_start`. -->
      <form class="public-form" action="/" [formGroup]="passwordResetForm" (submit)="changePassword()">
        <p class="screen-label">Nova senha</p>
        <p class="screen-hint">
          Escolha uma senha de no mínimo 8 caracteres e repita para confirmar.
        </p>

        <div class="form-group mt-4">
          <label for="password">Nova senha</label>
          <input
            type="password"
            class="form-control"
            formControlName="password"
          />
          <span *ngIf="passwordResetForm.get('password').touched">
            <small
              class="text text-danger"
              *ngIf="passwordResetForm.get('password').errors?.required"
            >
              Nova senha é obrigatória
            </small>
            <small
              class="text text-danger"
              *ngIf="passwordResetForm.get('password').errors?.minlength"
            >
              A nova senha deve ter no mínimo 8 caracteres
            </small>
          </span>
        </div>

        <div class="form-group">
          <label for="password_confirmation">Confirmação da nova senha</label>
          <input
            type="password"
            class="form-control"
            formControlName="password_confirmation"
          />
          <span *ngIf="passwordResetForm.get('password_confirmation').touched">
            <small
              class="text text-danger"
              *ngIf="
                passwordResetForm.get('password_confirmation').errors?.required
              "
            >
              Confirmação da nova senha é obrigatória
            </small>
            <small
              class="text text-danger"
              *ngIf="
                passwordResetForm.get('password_confirmation').errors?.minlength
              "
            >
              A nova senha deve ter no mínimo 8 caracteres
            </small>
            <small
              class="text text-danger"
              *ngIf="
                passwordResetForm.get('password_confirmation').errors
                  ?.different
              "
            >
              Nova senha não foi confirmada corretamente
            </small>
          </span>
        </div>

        <div class="form-group d-grid">
          <button
            class="btn btn-primary"
            [appLoadingButton]="isLoading"
            [disabled]="passwordResetForm.invalid"
            data-testid="btn-change-password"
          >
            Alterar
          </button>
        </div>
      </form>
    </div>
  </div>
</main>
